<template>
  <div
    :class="[
      'add-new-popup z-[999] fixed transition-all inset-0 overflow-x-hidden overflow-y-auto lg:py-[20px]',
      { active: stateStoreInstance.active },
    ]"
  >
    <div
      class="popup-dialog flex transition-all max-w-[550px] min-h-full items-center mx-auto"
    >
      <div
        class="trezo-card w-full bg-white dark:bg-[#0c1427] p-[20px] md:p-[25px] rounded-md"
      >
        <div
          class="trezo-card-header bg-gray-50 dark:bg-[#15203c] mb-[20px] md:mb-[25px] flex items-center justify-between -mx-[20px] md:-mx-[25px] -mt-[20px] md:-mt-[25px] p-[20px] md:p-[25px] rounded-t-md"
        >
          <div class="trezo-card-title">
            <h5 class="mb-0">{{ directT('crm.deals.form.title') }}</h5>
          </div>
          <div class="trezo-card-subtitle">
            <button
              type="button"
              class="text-[23px] transition-all leading-none text-black dark:text-white hover:text-primary-500"
              @click="stateStoreInstance.activeBtn"
            >
              <i class="ri-close-fill"></i>
            </button>
          </div>
        </div>

        <div class="trezo-card-content">
          <div v-if="error" class="mb-4 p-3 bg-red-50 text-red-500 rounded-md">
            {{ error }}
          </div>
          <form @submit.prevent="saveDeal">
            <div class="sm:grid sm:grid-cols-2 sm:gap-[25px]">
              <div class="sm:col-span-2 mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('crm.deals.form.dealTitle') }}
                </label>
                <input
                  v-model="newDeal.title"
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('crm.deals.form.dealTitlePlaceholder')"
                  required
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('crm.deals.form.contactPerson') }}
                </label>
                <input
                  v-model="newDeal.name"
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('crm.deals.form.contactPersonPlaceholder')"
                  required
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('crm.deals.form.phone') }}
                </label>
                <input
                  v-model="newDeal.phone"
                  type="text"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('crm.deals.form.phonePlaceholder')"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('crm.deals.form.amount') }}
                </label>
                <input
                  v-model="newDeal.amount"
                  type="number"
                  step="0.01"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('crm.deals.form.amountPlaceholder')"
                />
              </div>
              <div class="mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('crm.deals.form.status') }}
                </label>
                <select
                  v-model="newDeal.status"
                  class="h-[55px] rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] px-[14px] block w-full outline-0 cursor-pointer transition-all focus:border-primary-500"
                  required
                >
                  <option value="new">{{ directT('crm.deals.form.statusOptions.new') }}</option>
                  <option value="in progress">{{ directT('crm.deals.form.statusOptions.inProgress') }}</option>
                  <option value="on hold">{{ directT('crm.deals.form.statusOptions.onHold') }}</option>
                  <option value="pending">{{ directT('crm.deals.form.statusOptions.pending') }}</option>
                  <option value="negotiation">{{ directT('crm.deals.form.statusOptions.negotiation') }}</option>
                  <option value="closed">{{ directT('crm.deals.form.statusOptions.closed') }}</option>
                </select>
              </div>
              <div class="sm:col-span-2 mb-[20px] sm:mb-0">
                <label
                  class="mb-[10px] text-black dark:text-white font-medium block"
                >
                  {{ directT('crm.deals.form.description') }}
                </label>
                <textarea
                  v-model="newDeal.description"
                  rows="3"
                  class="rounded-md text-black dark:text-white border border-gray-200 dark:border-[#172036] bg-white dark:bg-[#0c1427] p-[17px] block w-full outline-0 transition-all placeholder:text-gray-500 dark:placeholder:text-gray-400 focus:border-primary-500"
                  :placeholder="directT('crm.deals.form.descriptionPlaceholder')"
                ></textarea>
              </div>
            </div>
            <div class="mt-[20px] md:mt-[25px] ltr:text-right rtl:text-left">
              <button
                type="button"
                class="rounded-md inline-block transition-all font-medium ltr:mr-[15px] rtl:ml-[15px] px-[26.5px] py-[12px] bg-danger-500 text-white hover:bg-danger-400"
                @click="stateStoreInstance.activeBtn"
              >
                {{ directT('crm.deals.form.cancel') }}
              </button>
              <button
                type="submit"
                class="inline-block bg-primary-500 text-white py-[12px] px-[26.5px] transition-all rounded-md hover:bg-primary-400"
                :disabled="loading"
              >
                <span v-if="!loading" class="inline-block relative ltr:pl-[25px] rtl:pr-[25px]">
                  <i
                    class="material-symbols-outlined !text-[20px] absolute ltr:left-0 rtl:right-0 top-1/2 -translate-y-1/2"
                  >
                    add
                  </i>
                  {{ directT('crm.deals.form.create') }}
                </span>
                <span v-else>
                  {{ directT('crm.deals.form.saving') }}
                </span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive } from "vue";
import stateStore from "@/utils/store";
import { supabase } from "@/lib/supabaseClient";
import { getCurrentOrgId } from "@/utils/getCurrentOrgId";
import emitter from "@/utils/emitter";
import { useI18n } from 'vue-i18n';
import enTranslations from '@/i18n/locales/en.json';
import heTranslations from '@/i18n/locales/he.json';
import arTranslations from '@/i18n/locales/ar.json';

type TranslationObject = Record<string, any>;

interface NewDeal {
  title: string;
  name: string;
  phone: string;
  amount: number | null;
  description: string;
  status: string;
  organization_id: string | null;
  created_by: string | null;
}

export default defineComponent({
  name: "AddNewDealPopup",
  setup() {
    const stateStoreInstance = stateStore;
    const loading = ref(false);
    const error = ref<string | null>(null);
    const { locale } = useI18n();
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };

    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    const newDeal = reactive<NewDeal>({
      title: '',
      name: '',
      phone: '',
      amount: null,
      description: '',
      status: 'new',
      organization_id: null,
      created_by: null,
    });

    const clearForm = () => {
      newDeal.title = '';
      newDeal.name = '';
      newDeal.phone = '';
      newDeal.amount = null;
      newDeal.description = '';
      newDeal.status = 'new';
    };

    const saveDeal = async () => {
      try {
        loading.value = true;
        error.value = null;
        
        // Get current user and organization
        const { data: userData, error: userError } = await supabase.auth.getUser();
        if (userError) throw userError;
        
        const organizationId = await getCurrentOrgId();
        if (!organizationId) {
          throw new Error(directT('crm.deals.form.error'));
        }
        
        // Set organization ID and creator ID
        newDeal.organization_id = organizationId;
        newDeal.created_by = userData.user?.id || null;
        
        // Insert the deal into the database
        const { error: insertError } = await supabase
          .from('deals')
          .insert(newDeal);
          
        if (insertError) throw insertError;
        
        // Clear form and close modal
        clearForm();
        stateStoreInstance.activeBtn();
        
        // Emit event to refresh deals list
        emitter.emit('refresh-deals');
        
      } catch (err) {
        console.error('Error saving deal:', err);
        error.value = err instanceof Error ? err.message : directT('crm.deals.form.error');
      } finally {
        loading.value = false;
      }
    };

    return {
      stateStoreInstance,
      newDeal,
      loading,
      error,
      saveDeal,
      directT
    };
  },
});
</script>
